import { render } from "./RequestPasswordReset.vue?vue&type=template&id=79837f50&scoped=true"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js"

import "./RequestPasswordReset.vue?vue&type=style&index=0&id=79837f50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79837f50"]])

export default __exports__